// extracted by mini-css-extract-plugin
module.exports = {"main_wrapper":"Main_main_wrapper__33J0y"};